import { InfoActionSheetProps } from './info-action-sheet.types';

export const isVariantWithStatusIcon = (variant: InfoActionSheetProps['variant']) => {
  return variant ? ['congrats', 'not-verified', 'verified'].includes(variant) : false;
};
